import { Children, cloneElement } from "react";
import { blockParser } from "../lib/utils/block-parser";
import { arrayOf, object, string } from "prop-types";

/**
 * BodyContent - component that renders the body content of the page.
 * @param {Object} props - determines the properties needed for the components
 * @returns Children node with array of components
 */
const BodyContent = (props) => {
  const {
    pricingContext,
    externalData,
    blocks,
    logTrace,
    metaData,
    err,
    urlParamsProps
  } = props;

  const context = {
    pricingContext,
    externalData,
    // urlParamsProps contains location-based URL parameters (state, city) used for
    // rendering location-specific content like labor law pages
    urlParamsProps
  };

  const body = blocks
    ? blockParser({ blocks, logTrace, context, metaData })
    : err;

  return Children.map(body, (child) => child && cloneElement(child));
};

BodyContent.defaultProps = {
  pricingContext: {},
  externalData: {}
};

BodyContent.propTypes = {
  pricingContext: object,
  externalData: object,
  blocks: arrayOf(object).isRequired,
  logTrace: string.isRequired
};

export default BodyContent;
